module.exports = __webpack_public_path__ + "img/logo-vrchat_ex.af3297bb.png";